import { api } from '../../../api';

export interface RestaurantHeroImages {
  imageKeys: string[];
}

export const restaurantHeroImagesQueryKey = (restaurantId: string) =>
  ['restaurants', restaurantId, 'hero-images'] as const;

export const getRestaurantHeroImages = async (
  restaurantId: string,
): Promise<RestaurantHeroImages> =>
  api.get(`/restaurants/${restaurantId}/hero-images`);

export const getRestaurantHeroImageUploadUrl = (
  restaurantId: string,
  contentType: string,
) =>
  api.get<{
    objectKey: string;
    signedUploadImageUrl: string;
    signedGetImageUrl: string;
    contentType: string;
  }>(
    `/restaurants/${restaurantId}/hero-images/upload-url?contentType=${encodeURIComponent(contentType)}`,
  );
